import React, {useCallback, useEffect} from 'react';
import {Icon, PaginationTable, Select} from "../../../components";
import {withRouter} from 'react-router-dom';
import {
    getTotalPagesAdministrators,
    getListAdministrators,
    getNumberTotalAdministrators,
} from "../../../redux/selectors";
import {connect} from "react-redux";
import {
    setAdministratorSearch, setAdministratorFilter, setAdministratorRowsPerPage,
    editAdministrator, setSortAdministrator, setAdministratorPage, startAdmins
} from "../../../redux/actions";

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {arrowsAlt, check, editAdmin, remove, search, times, user} from "../../../utils/icons";
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import FormatDate from "../../../components/formatDate";


const AdministratorsTable = (props) => {


    const {
        listAdministrators, listStatus, listNames, totalPages, rowsPerPage, page,
        setAdministratorRowsPerPage, listOrganisations, editAdministrator, setSortAdministrator, setAdministratorPage,
        setShowDialogBox, setShowModal, columns, startAdmins, totalAdministrators
    } = props;


    const handleAdministratorFetch = useCallback(async () => {
        await startAdmins();
    }, []);


    useEffect(() => {
        handleAdministratorFetch();
    }, []);


    const handleChangePage = (event, newPage) => {
        setAdministratorPage(newPage);
    };


    return (


        <div className="main-container fade-in">


            <div className="container-table-filters ">
                <div className="filters filter-by-ref">
                    <div className="filter-title">
                        <span>SEARCH BY</span>
                    </div>
                    <div className="filter-content">
                        <input type="text"
                               placeholder={"Type to search"}
                               onChange={(event) => props.setAdministratorSearch(event.target.value)}
                        />
                        <img className="search" src={search} alt="search-icons"/>

                    </div>

                </div>

                <div className="filters filter-by-name">

                    <div className="filter-title">
                        <img className="search" src={user} alt="user-icons"/>
                        <span>name</span>
                    </div>
                    <div className="filter-content">

                        <Autocomplete
                            id="free-solo-filter"
                            className={"autocomplete-filter"}
                            freeSolo
                            options={listNames && listNames.map((option) => option)}
                            onChange={(event, value) => props.setAdministratorFilter('fullName', value)}

                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Name"
                                    className={"textField-filter"}
                                    size={"small"}
                                    margin="normal"
                                    variant="outlined"
                                />
                            )}
                        />

                    </div>


                </div>

                <div className="filters filter-by-status">

                    <div className="filter-title">
                        <img className="search" src={arrowsAlt} alt="arrowsAlt-icons"/>
                        <span>organisation</span>
                    </div>
                    <div className="filter-content">
                        <Select list={listOrganisations}
                                value={props.filterOrganisation}
                                type="organisation"
                                handleChange={props.setAdministratorFilter}
                        />

                    </div>


                </div>


                <div className="filters filter-by-date">

                    <div className="filter-title">
                        <img className="search" src={arrowsAlt} alt="arrowsAlt-icons"/>
                        <span>role</span>
                    </div>
                    <div className="filter-content">

                        <Select list={listStatus}
                                value={props.filterStatus}
                                type="status"
                                handleChange={props.setAdministratorFilter}
                                keyValue
                        />

                    </div>


                </div>

            </div>


            <div className="table-wrapper">

                <Paper className="paper-container">
                    <TableContainer className={"table-container"}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow className="table-row-header">
                                    {columns.map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{minWidth: column.minWidth}}
                                        >

                                            {
                                                column.isButton ?
                                                    <CustomButton _onClick={() => setSortAdministrator(column.id)}
                                                                  text={column.label}/> :
                                                    column.label

                                            }
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {listAdministrators && listAdministrators.map(({userId, fullName, organisation, roleName, created, active}) => {


                                    let row = createData(userId, fullName, organisation, roleName, created, active);

                                    return (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={row.userId}
                                                  className={!row.active ? 'row removed' : 'row'}>
                                            {columns.map((column) => {
                                                const value = row[column.id];
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        {column.id === 'edit' ?
                                                            <ActionsComponent id={row.userId}
                                                                              editAdministrator={editAdministrator}
                                                                              setShowModal={setShowModal}
                                                                              setShowDialogBox={setShowDialogBox}
                                                                              key={`actions-${column.id}`}/> :
                                                            column.id === 'active' ?
                                                                <StatusComponent
                                                                    key={`status-${column.id}`}
                                                                    value={value}/> :

                                                                column.id === 'created' ?
                                                                    <FormatDate
                                                                        key={`created-${column.id}`}
                                                                        date={value}/> :

                                                                    value}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>


                </Paper>

                <PaginationTable
                    rowsPerPage={rowsPerPage}
                    setRowsPerPage={setAdministratorRowsPerPage}
                    totalPages={totalPages}
                    page={page}
                    handleChangePage={handleChangePage}
                    totalItem={totalAdministrators}
                />

            </div>

        </div>


    );
}


const mapStateToProps = (state) => {
    const listAdministrators = getListAdministrators(state);

    const listStatus = state.administrators.status;
    const listOrganisations = state.administrators.organisations;
    const listNames = state.administrators.names;
    const filterStatus = state.administrators.filterStatus;
    const filterName = state.administrators.filterName;
    const filterOrganisation = state.administrators.filterOrganisation;
    const rowsPerPage = state.administrators.rowsPerPage;
    const page = state.administrators.currentPage;
    const totalPages = getTotalPagesAdministrators(state);
    const totalAdministrators = getNumberTotalAdministrators(state);
    return {
        listAdministrators, listStatus, filterStatus, listNames, filterName, filterOrganisation,
        rowsPerPage, page, totalPages, listOrganisations, totalAdministrators
    };
};


export default connect(mapStateToProps,
    {
        startAdmins, setAdministratorSearch, setAdministratorFilter, setAdministratorRowsPerPage,
        editAdministrator, setSortAdministrator, setAdministratorPage
    })(withRouter(AdministratorsTable));


function createData(userId, fullName, organisation, roleName, created, active) {
    const edit = 4565;
    return {userId, fullName, organisation, roleName, created, active, edit};
}


const CustomButton = ({text, _onClick}) => {
    return (
        <button style={{color: 'white', fontWeight: 500}}
                onClick={_onClick}
        >{text}</button>
    )
}

const ActionsComponent = ({id, editAdministrator, setShowModal, setShowDialogBox}) => {

    const handleEdit = () => {
        editAdministrator(id);
        setShowModal(true);
    }

    return (
        <div className="actions-container">
            <button className="btn" onClick={handleEdit}>
                <Icon path={editAdmin} alt="checked-icon" iconclass={"icon-check"}/>
            </button>
            <button className="btn" onClick={() => setShowDialogBox(id)}>
                <Icon path={remove} alt="checked-icon" iconclass={"icon-check"}/>
            </button>
        </div>
    );
}


const StatusComponent = ({value}) => {

    if (value)
        return (<Icon path={check} alt="checked-icon" iconclass={"icon-check"}/>);
    else
        return (<Icon path={times} alt="remove-icon" iconclass={"icon-times-removed"}/>);

}
